import React, { FC } from 'react'
import { UISizes, UITypes, i18n, TooltipComponent, UIPlacement } from 'LibNeo'
import { XOR } from 'Helpers'
import { AutoTestsProps } from 'Types/autoTests'
import { LinkComponentStyled, LinkIconComponentStyled, LinkStyled } from './styled'

export type LinkProps = {
	type?:
		| UITypes.PRIMARY
		| UITypes.PASSIVE
		| UITypes.DANGER
		| UITypes.INFO
		| UITypes.WARNING
		| UITypes.BLACK
	size?: UISizes.NORMAL | UISizes.SMALL
	inText?: boolean // для отображения ссылки в тексте
	disabled?: boolean
	className?: string
	tooltip?: string
	defaultVisibleTooltip?: boolean
	placement?: UIPlacement
} & XOR<
	{
		url?: string
		external?: boolean
		title?: string
		onClick?: (event: React.MouseEvent) => void
		iconName?: string
	},
	{
		title: string
		onClick: (event: React.MouseEvent) => void
		iconName?: string
	}
>

export const LinkComponent: FC<LinkProps & AutoTestsProps> = ({
	type = UITypes.PRIMARY,
	size = UISizes.NORMAL,
	title,
	inText = false,
	iconName,
	disabled = false,
	url,
	className,
	external = false,
	onClick,
	dataQa,
	tooltip,
	placement = UIPlacement.TOP,
	defaultVisibleTooltip,
}) => {
	const titleForLink = i18n(title) || url?.replace(/^https?:\/\/(www.)?|mailto:|tel:/, '')

	if (!url) {
		return (
			<TooltipComponent
				defaultVisible={defaultVisibleTooltip}
				title={tooltip}
				placement={placement}
			>
				<LinkComponentStyled
					hasAction={Boolean(onClick)}
					inText={inText}
					disable={disabled}
					isSmall={size === UISizes.SMALL}
					type={type}
					tabIndex={-1}
					className={className}
					onClick={onClick}
					data-qa={dataQa}
					as="span"
				>
					{titleForLink}
					{iconName && <LinkIconComponentStyled name={iconName} size={UISizes.SMALL} />}
				</LinkComponentStyled>
			</TooltipComponent>
		)
	}
	if (external) {
		return (
			<TooltipComponent
				defaultVisible={defaultVisibleTooltip}
				title={tooltip}
				placement={placement}
			>
				<LinkComponentStyled
					hasAction={Boolean(onClick)}
					inText={inText}
					disable={disabled}
					isSmall={size === UISizes.SMALL}
					type={type}
					className={className}
					href={url}
					target="_blank"
					rel="noopener noreferrer"
					data-qa={dataQa}
					onClick={onClick}
					as="a"
				>
					{titleForLink}
					<LinkIconComponentStyled name="link-out" size={UISizes.SMALL} />
				</LinkComponentStyled>
			</TooltipComponent>
		)
	}

	return (
		<TooltipComponent defaultVisible={defaultVisibleTooltip} title={tooltip} placement={placement}>
			<LinkStyled className={className} to={url} data-qa={dataQa} onClick={onClick} type={type}>
				{titleForLink}
				{iconName && <LinkIconComponentStyled name={iconName} size={UISizes.SMALL} />}
			</LinkStyled>
		</TooltipComponent>
	)
}
